import { render, staticRenderFns } from "./CreateServiceModal.vue?vue&type=template&id=18c1ca90&scoped=true&"
import script from "./CreateServiceModal.vue?vue&type=script&lang=js&"
export * from "./CreateServiceModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateServiceModal.vue?vue&type=style&index=0&id=18c1ca90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c1ca90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18c1ca90')) {
      api.createRecord('18c1ca90', component.options)
    } else {
      api.reload('18c1ca90', component.options)
    }
    module.hot.accept("./CreateServiceModal.vue?vue&type=template&id=18c1ca90&scoped=true&", function () {
      api.rerender('18c1ca90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Services/Modals/CreateServiceModal.vue"
export default component.exports